import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Typography, Tabs } from "antd";
import {
  ProductOutlined,
  StockOutlined,
  FileDoneOutlined,
} from "@ant-design/icons";
import MainHeader from "../../components/common/MainHeader";
import WoodMenusView from "./WoodMenusView";
import InterfaceMicrosoftAXView from "./InterfaceMicrosoftAXView";
import ReportView from "./ReportView";
import { Content } from "antd/es/layout/layout";

import { PATH } from "../../routes/Routes";
import { useHistory } from "react-router-dom";
import { useUserContext } from "../../hooks/UserSettingProvider";
import { Button, Col, Row } from "antd";
import { RightOutlined } from "@ant-design/icons";
import { Media } from "../../AppMedia";

const LandingPageView = () => {
  const { Title } = Typography;
  const { t } = useTranslation();

  const history = useHistory();
  const { user } = useUserContext();
  const handleMenuClick = (path) => {
    history.push(path);
  };
  const adminMenu = [
    {
      id: "LOG_WOOD_PO",
      name: t("menus.wood_menus.log_wood_po"),
      onClick: () => handleMenuClick(PATH.LOG_WOOD_PO),
    },
    {
      id: "WOOD_IMPORT",
      name: t("menus.wood_menus.wood_import"),
      onClick: () => handleMenuClick(PATH.WOOD_IMPORT),
    },
    {
      id: "WOOD_IMPORT_SETTINGS_PRICE",
      name: t("menus.wood_menus.post_baking_waste_wood_count"),
      onClick: () => handleMenuClick(PATH.POST_BAKING_WASTE_WOOD_COUNT),
    },
    {
      id: "FACTORY_WOOD_EXPORT",
      name: t("menus.wood_menus.post_baking_waste_wood_input"),
      onClick: () => handleMenuClick(PATH.POST_BAKING_WASTE_WOOD_INPUT),
    },
  ];

  return (
    <div>
      <MainHeader hide={false} />
      <Media greaterThan={"sm"}>
        <Content
          style={{ margin: "24px", marginTop: "7em", }}
        >
          <Title level={1}>WoodWork</Title>
          <Tabs defaultActiveKey="wood_menu" centered>
            <Tabs.TabPane
              tab={
                <span style={{ fontWeight: "bold" }}>
                  <ProductOutlined /> {t("menus.wood_menu")}
                </span>
              }
              key="wood_menu"
            >
              <WoodMenusView />
            </Tabs.TabPane>

            <Tabs.TabPane
              tab={
                <span style={{ fontWeight: "bold" }}>
                  <FileDoneOutlined /> {t("menus.interface_ax")}
                </span>
              }
              key="interface_ax"
            >
              <InterfaceMicrosoftAXView />
            </Tabs.TabPane>

            <Tabs.TabPane
              tab={
                <span style={{ fontWeight: "bold" }}>
                  <StockOutlined /> {t("menus.report")}
                </span>
              }
              key="report"
            >
              <ReportView />
            </Tabs.TabPane>
          </Tabs>
        </Content>{" "}
      </Media>
      <Media at={"sm"}>
        <Content
          style={{ margin: "24px", marginTop: "10em", fontWeight: "bold" }}
        >
          <Typography.Title level={1}>WoodWork</Typography.Title>
          {adminMenu.map((menu) => (
            <Row>
              <Col
                xs={{ span: 24 }}
                sm={{ offset: 7, span: 12 }}
                md={{ offset: 6, span: 13 }}
              >
                <br />
                <Button
                  onClick={menu.onClick}
                  type="primary"
                  size="large"
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  {menu.name}
                  <RightOutlined />
                </Button>
              </Col>
            </Row>
          ))}
        </Content>
      </Media>
    </div>
  );
};

export default LandingPageView;
